import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LtePlusMobiledataIcon(props: IconProps) {
    return <Icon {...props} iconKey={"lte_plus_mobiledata"}/>
}
